import React, { useEffect, useState } from 'react';
import { Tag } from "../typings";
import { updateTagName } from "./tags-api";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/react";
import { MdOutlineMoreVert } from "react-icons/md";
import EditableTextInput from "../components/EditableTextInput";
import ConfirmationDialog from "./ConfirmationDialog";
import { toast } from "react-toastify";
import { ApiContextType } from "../api-context";

interface Props {
    api: ApiContextType;
    tags: Tag[];
    tag: Tag;
    onRemove: (id: number) => void;
}

function TagCard(props: Props) {
    const [editMode, setEditMode] = useState(false);
    const [dialogOpen, setDialogOpen] = useState(false);
    const [name, setName] = useState(props.tag.name);
    const [valid, setValid] = useState(false);

    useEffect(() => {
        setValid(!!name && !props.tags.find(tag => tag.name === name));
    }, [name, props.tags]);


    const onUpdateTag = (id: number, name: string) => {
        updateTagName(props.api, id, name)
            .then(() => toast.success('Successfully updated tag'))
            .catch(() => toast.error('Failed to update tag'));
    }

    return (
        <div className="box" style={{
            flexDirection: 'row' as 'row',
            padding: '2px 8px'
        }}>
            <EditableTextInput
                disabled={!valid}
                editable={editMode}
                onChange={name => setName(name?.toUpperCase())}
                onClose={() => setEditMode(false)}
                value={props.tag.name?.toUpperCase()}
                setValue={(name) => onUpdateTag(props.tag.id, name?.toUpperCase())}
            />
            {
                !props.tag.predefined && !props.tag.readOnly ? (
                    <Menu>
                        <MenuButton className="menu-button"><MdOutlineMoreVert size="24px"/></MenuButton>
                        <MenuItems
                            className="menu-box"
                            anchor="bottom"
                        >
                            <MenuItem>
                                <div className="menu-item" onClick={() => setEditMode(true)}>
                                    Edit
                                </div>
                            </MenuItem>
                            <MenuItem>
                                <div className="menu-item" onClick={() => setDialogOpen(true)}>
                                    Remove
                                </div>
                            </MenuItem>
                        </MenuItems>
                    </Menu>
                ) : null
            }
            <ConfirmationDialog
                title="Delete tag"
                description="Are you sure you want to delete this tag? The tag will be deleted and removed from all files."
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                onConfirm={() => {
                    props.onRemove(props.tag.id);
                    setDialogOpen(false);
                }}
            />
        </div>
    );
}

export default TagCard;
